import { axiosApi, axiosAuthApi } from 'services/api';
import { handleApiError } from 'utils/apiUtils';

// Get Chat List API
export const getChatList = async (header, data) => {
    try {
        const response = await axiosAuthApi(header).post("/get/chats", data);
        return response;
    } catch (error) {
        throw handleApiError(error);
    }
};

// Get Messages List
export const getMessagesList = async (header, formData, chat_id) => {
    try {
        const response = await axiosAuthApi(header).post("/get/chat", formData);
        return response;
    } catch (error) {
        throw handleApiError(error);
    }
};

// Get Paginated Messages List
export const getMessagesListPaginated = async (header, formData, currentPage) => {
    try {
        const response = await axiosAuthApi(header).post(`/get/chat?page=${currentPage + 1}`, formData);
        return response;
    } catch (error) {
        throw handleApiError(error);
    }
};

// Accept Offer API function
export const acceptOffer = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/offer/accept", formData);
        return response;
    } catch (error) {
        throw error; // will be handled in the action
    }
};

// Get Unread Message Count API function
export const getUnreadMessageCount = async (token) => {
    try {
        const response = await axiosApi.get("/get/unread-messages", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error) {
        throw error; // will be handled in the action
    }
};

// Mark Single Chat as Read API function
export const markSingleChatAsRead = async (header, data) => {
    try {
        const response = await axiosAuthApi(header).post("/mark/single/chat/read", data);
        return response;
    } catch (error) {
        throw error; // will be handled in the action
    }
};

// Make Payment API function
export const makePayment = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/payment/make", formData);
        return response;
    } catch (error) {
        throw error; // will be handled in the action
    }
};

export const buyPackPaymentApi = async (header, data) => {
    try {
        const response = await axiosAuthApi(header).post("/buy/pack", data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const rejectOfferApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/offer/reject", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

export const submitWorkApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/work/submit", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

export const acceptSubmitWorkApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/work/accept", formData);
        return response;
    } catch (error) {
        throw error;
    }
};
export const askAdjustmentApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/ask/adjustment", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

export const submitLinkApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/submit/link", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

export const addReviewApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("collaboration/review/add", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

export const acceptLinkApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/link/accept", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

export const rejectLinkApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/link/reject", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

// Report Issue API
export const reportIssueApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/report/issue", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

// Accept Extension API
export const acceptExtensionApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/accept/extension", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

// Reject Extension API
export const rejectExtensionApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/reject/extension", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

// Submit Extension API
export const submitExtensionApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/ask/extension", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

// Send Custom Offer API
export const sendCustomOfferApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/offer/create", formData);
        return response;
    } catch (error) {
        throw error;
    }
};
// Submit Appeal API
export const submitAppealApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/appeal", formData);
        return response;
    } catch (error) {
        throw error;
    }
};

// Get Current Chat Stage API
export const getCurrentChatStageApi = async (header, currentChatId) => {
    try {
        const response = await axiosAuthApi(header).post("/get/current/stage", {
            collaboration_id: currentChatId,
        });
        return response;
    } catch (error) {
        throw error;
    }
};

// Mark all messages as read
export const allMsgReadCall = (header) => {
    return axiosAuthApi(header).get("/mark/chat/read");
};

// Mark a specific message as read
export const markMsgAsReadCall = (header, data) => {
    return axiosAuthApi(header).post("/mark/message/read", data);
};

// Get filtered chat list
export const getFilteredChatListCall = (header, data) => {
    return axiosAuthApi(header).post("/get/chats", data);
};

// Send message to receiver
export const sendMessageToReceiver = (header, formData) => {
    return axiosAuthApi(header).post("/message/send", formData);
};

export const getPendingCollaborationsCount = async (header, data) => {
    try {
        const response = await axiosAuthApi(header).post(
            "/get/pending/collaborations/count",
            data
        );
        return response; // Return the successful response
    } catch (error) {
        throw error; // If an error occurs, throw it to be caught in the action
    }
};

//   // API call to mark a single chat as read
// export const markSingleChatAsRead = async (header, data) => {
//     try {
//       const response = await axiosAuthApi(header).post("/mark/single/chat/read", data);
//       return response;
//     } catch (error) {
//       throw error; // Throw error to be handled in the action
//     }
//   };

// API call to make a payment for the brand
export const makePaymentBrand = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post("/payment/make", formData);
        return response;
    } catch (error) {
        throw error; // Throw error to be handled in the action
    }
};


export const releasePaymentToCreatorApi = async (header, formData) => {
    try {
        const response = await axiosAuthApi(header).post(
            "/release-payment-to-creator",
            formData
        );
        return response;
    } catch (error) {
        throw error;
    }
};

// Payment Preview API function
export const getOfferPaymentPreview = async (header, offerId) => {
  try {
    const response = await axiosAuthApi(header).get(`/offer/${offerId}/payment-preview`);
    return response; // response.data sẽ chứa offer_amount, processing_fee, total, v.v.
  } catch (error) {
    throw error; // để action phía trên handle
  }
};